export const shopName = "Bracelet Shop";
